export const LO_STO = {
    ARTICLES: 'ARTICLES'
}


// WEBPACK FOOTER //
// ./src/lib/constants.js